<template>
  <ul class="mdl-list">
    <li class="mdl-list__title">{{ data.fecha || '?' }}</li>
    <li>
      <ul class="mdl-list" v-for="(auditor, index) in data.auditores" :data-index="index">
        <li class="mdl-list__item mdl-list__item--two-line" main-item>
          <span class="mdl-list__item-primary-content">
            <i class="material-icons mdl-list__item-avatar"
              :style="{ backgroundImage: 'url('+auditor.avatar+')' || '' }"></i>
            <span>{{ auditor.nombre }}</span>
            <span class="mdl-list__item-sub-title">{{ auditor.rol }}</span>
          </span>
          <span class="mdl-list__item-secondary-content">
            <span class="mdl-list__item-secondary-info">{{ auditor.auditorias.length }} Auditorías</span>
          </span>
        </li>

        <li v-for="(auditoria, index) in auditor.auditorias" @click="showReport" :data-index="index"
          :class="['audit', 'mdl-list__item', 'mdl-list__item--two-line',
                  auditoria.statusId >= 3 ? 'bg-green-light' : '']">
          <span class="mdl-list__item-primary-content">
            <!-- <i class="material-icons mdl-list__item-avatar"
              :style="{ backgroundImage: 'url('+auditoria.imagen+')'}"></i> -->
            <span class="mdl-list__item-title">{{ auditoria.inmueble }}</span>
            <span class="mdl-list__item-sub-title">{{ auditoria.empresa }}</span>
          </span>
          <span class="mdl-list__item-secondary-content">
            <span class="mdl-list__item-sub-title">{{ auditoria.incidencias }}</span>
            <span class="mdl-list__item-secondary-info">Incidencias</span>
          </span>
          <span class="mdl-list__item-secondary-content">
            <span :class="['mdl-list__item-sub-title',
              auditoria.promedio >= auditoria.aceptable ? 'color-green-light' :
              ( auditoria.promedio > auditoria.inaceptable ? 'color-yellow' : 'color-red' )]">{{ auditoria.promedio }}</span>
            <span class="mdl-list__item-secondary-info">Puntos</span>
          </span>
          <span class="mdl-list__item-secondary-content">
            <span :class="['mdl-list__item-secondary-info',
              auditoria.statusId >= 3 ? 'color-green-light' :
              auditoria.statusId === 2 ? 'color-yellow' : '']">{{ auditoria.statusNombre }}</span>
          </span>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
export default {
  props: ['data'],
  data () {
    return {
      actionbar: {}
    }
  },
  methods: {
    showReport (event) {
      let item = event.currentTarget,
          itemParent = event.currentTarget.parentNode,
          auditores = this.data.auditores,
          itemIndex = item.dataset.index,
          itemParentIndex = itemParent.dataset.index,
          auditoria = auditores[itemParentIndex].auditorias[itemIndex]

      if (auditoria.mantenimiento) {
        if (typeof auditoria.mantenimiento === 'string') {
          auditoria.mantenimiento = JSON.parse(auditoria.mantenimiento)
        }
      } else {
        auditoria.mantenimiento = {}
      }

      this.$emit('showReport', auditoria)
    }
  },
  mounted () {
    this.$actionbar.init(this.actionbar)
  }
}
</script>

<style lang="css" scoped>
  .audit {
    cursor: pointer;
  }

  .mdl-list .mdl-list__title {
    /*margin-left: 1rem;*/
  }

  .mdl-list .mdl-list__item[main-item] {
    height: 0;
    /*border-bottom: 2px solid #e6e5e5;*/
  }

  .mdl-list .mdl-list__item {
    background-color: #fff;
  }

  .mdl-list .mdl-list__item-primary-content {
    width: 50%
  }

  .mdl-list .mdl-list__item-primary-content .mdl-list__item-title {
    display: block;
    /*margin-top: 6px;*/
    font-weight: bolder;
    font-size: 1rem;
  }

  .mdl-list .mdl-list__item-secondary-content {
    width: 12.50%;
  }

  .mdl-list .mdl-list__item-secondary-content .mdl-list__item-sub-title {
    display: block;
    width: 100%;
    font-size: 1.25rem;
    font-weight: bolder;
    line-height: 1.5;
    text-align: center;
  }

  .mdl-list .mdl-list__item-secondary-content .mdl-list__item-secondary-info {
    display: block;
    width: 100%;
    font-weight: bolder;
    font-size: 0.75rem;
    text-align: center;
    text-transform: uppercase;
  }
</style>


// WEBPACK FOOTER //
// List.vue?b63c45fe